import { render, staticRenderFns } from "./SignInPopup.vue?vue&type=template&id=55f7245f&scoped=true"
import script from "./SignInPopup.vue?vue&type=script&lang=js"
export * from "./SignInPopup.vue?vue&type=script&lang=js"
import style0 from "./SignInPopup.vue?vue&type=style&index=0&id=55f7245f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f7245f",
  null
  
)

export default component.exports